import { Navigate } from "react-router-dom";

export default function ProtectedRoute({ children, roles }) {
    const token = localStorage.getItem("authToken");
    const userRole = localStorage.getItem("userRole");

    if (!token) {
        return <Navigate to="/login" />;
    }

    if (roles && !roles.includes(userRole)) {
        return <Navigate to="/depannage" />; // ou page 403
    }

    return children;
}
